{
  "version": 1,
  "asset_id": "0ececc4f-5598-4471-b55f-2e9883cd3671",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/0ececc4f-5598-4471-b55f-2e9883cd3671/umair-320.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/0ececc4f-5598-4471-b55f-2e9883cd3671/umair-320.avif",
  "original_filename": "umair-320.avif",
  "size": 3003,
  "content_type": "image/avif",
  "created_at": "2026-08-02T02:38:10Z"
}
